import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class TWIABatchService {

    static findAllViewableBatchesForCurrentUser(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('bulkproducerchange'),
            'findAllViewableBatchesForCurrentUser',
            [],
            additionalHeaders
        );
    }

    static getBatchByCode(batchCode, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('bulkproducerchange'),
            'getBatchByCode',
            [batchCode],
            additionalHeaders
        );
    }

    static createOrUpdateBatch(batch, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('bulkproducerchange'),
            'createOrUpdateBatch',
            [batch],
            additionalHeaders
        );
    }

    static deleteBatches(idList,  additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('bulkproducerchange'),
            'deleteBatches',
            [idList],
            additionalHeaders
        );
    }

    static generateBookOfBusinessReport(criteria, opts, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('bulkproducerchange'),
            'generateBookOfBusinessReport',
            [criteria, opts],
            additionalHeaders
        );
    }

    static generateBooksOfBusinessReportCSV(criteria, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('bulkproducerchange'),
            'generateBooksOfBusinessReportCSV',
            [criteria],
            additionalHeaders
        );
    }

}